// EL FONDO DE LAS PANTALLAS DE ENTRAR DE BIANGO (t264d, 16-oct-2026)
//
// El dueño, al ver la entrada del portal del laboratorio: «mola la pantalla de fondo que has puesto al login de laboratorios,
// haz algo así más chulo en el /login de las clínicas». Este es el fondo de las dos, con su PALETA como parámetro:
//   · `fondoEscena(paleta)`: el estilo de la escena (las capas de luz en `paleta.capas`, la primera encima, sobre su color
//     de fondo), recortada para que sus formas no abran un desplazamiento de lado;
//   · `CapasEscena`: lo que va encima del fondo y debajo del contenido (zIndex -1 dentro de la `isolation` de la escena):
//     la trama de puntos que se desvanece y el arco del logotipo, grande y a media tinta, saliendo por la esquina (y, si la
//     paleta lo pide, un segundo arco fino).
// La del laboratorio vive en pages/lab/EscenaLab.jsx (PALETA_LAB) y sale EXACTAMENTE igual que antes de sacarla de allí (lo
// mide routes/login-escena-interactiva.test.js con su huella); la de /login, en pages/Login.jsx. Ninguna lleva un color de
// clínica: estas pantallas se pintan antes de saber de qué clínica se entra.
// Vive en utils/ (y lleva la marca de abajo) para que las guardias que montan estas pantallas lo carguen DE VERDAD sin
// tener que ponerle un doble:
//  @pintarJsx-con-react
// `movil: 'css'` (la de /login): pinta las dos formas y el corte lo hace la hoja de estilos de quien la usa
// (.escena-capas-movil / .escena-capas-ancha), sin preguntar el ancho desde aquí.
const ARCO = 'M8 58 A42 42 0 0 1 92 58'

export function fondoEscena(paleta) {
  return {
    position: 'relative', minHeight: 'var(--alto-pantalla)', overflow: 'hidden', boxSizing: 'border-box', isolation: 'isolate',
    color: '#ffffff', backgroundColor: paleta.fondo,
    backgroundImage: paleta.capas.join(', '),
  }
}

// `movil`: la forma del móvil (la trama arriba, el arco más grande y más metido). Decorado puro: aria-hidden y sin eventos.
// `sufijo`: para el id del degradado del arco cuando hay dos formas a la vez en la página (un degradado dentro de algo
// oculto no pinta, y dos con el mismo id se pisan).
export function CapasEscena({ paleta, movil = false, sufijo = '' }) {
  if (movil === 'css') {
    return (
      <>
        <span className="escena-capas-movil" style={{ display: 'contents' }}><CapasEscena paleta={paleta} movil sufijo="-movil" /></span>
        <span className="escena-capas-ancha" style={{ display: 'contents' }}><CapasEscena paleta={paleta} movil={false} sufijo="-ancha" /></span>
      </>
    )
  }
  const capa = { position: 'absolute', pointerEvents: 'none', zIndex: -1 }
  const mascara = movil ? paleta.mascaraMovil : paleta.mascara
  const a = paleta.arco
  const idArco = a.id + sufijo
  const i = movil ? 0 : 1
  const fino = paleta.arcoFino
  return (
    <>
      <span aria-hidden="true" {...(paleta.atributoTrama || {})} style={{
        ...capa, inset: 0, backgroundImage: 'radial-gradient(' + paleta.trama + ' 1px, transparent 1.5px)', backgroundSize: paleta.paso + 'px ' + paleta.paso + 'px',
        WebkitMaskImage: mascara, maskImage: mascara,
      }} />
      {/* El arco del logotipo: grande, a media tinta, saliendo por la esquina (como en la entrada del equipo). */}
      <svg aria-hidden="true" viewBox="0 0 100 60" style={{ ...capa, top: a.top[i], right: a.right[i], width: a.width[i], opacity: a.opacidad,
        WebkitMaskImage: a.mascara, maskImage: a.mascara }}>
        <defs>
          <linearGradient id={idArco} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor={a.colores[0]} />
            <stop offset="0.6" stopColor={a.colores[1]} />
            <stop offset="1" stopColor={a.colores[2]} />
          </linearGradient>
        </defs>
        <path d={ARCO} fill="none" stroke={'url(#' + idArco + ')'} strokeWidth="15" strokeLinecap="round" />
      </svg>
      {fino && !movil && (
        <svg aria-hidden="true" viewBox="0 0 100 60" style={{ ...capa, top: fino.top, right: fino.right, width: fino.width, opacity: fino.opacidad,
          WebkitMaskImage: a.mascara, maskImage: a.mascara }}>
          <path d={ARCO} fill="none" stroke={fino.color} strokeWidth={fino.grosor} strokeLinecap="round" />
        </svg>
      )}
    </>
  )
}
